import { Injectable } from '@angular/core';
import format from 'date-fns/format';
// eslint-disable-next-line no-restricted-imports
import { chain } from 'lodash';

import { GridSlot, GridSlotTime } from '@crm/shared/persons/tasks/types';

// TODO fix dependency (modules should depend on shared, not vice versa)
import { CalendarService } from 'app/wfm/shared';

const groupToDay = (group, day): { date: string; time: string } => {
  return {
    date: day,
    time: group,
  };
};

@Injectable()
export class ModSlotLessonIntroService {
  defaultTimeZone = 'Europe/Moscow';

  constructor(private calendarService: CalendarService) {}

  getGridTimezone(timeZone, slots: GridSlot[][]): GridSlot[][] {
    if (slots?.length && timeZone) {
      let slotsSortMod = this.groupSortSlots(timeZone, this.slotModTime(timeZone, slots[0]));
      if (slotsSortMod[0].time.some(item => item.isAvailable || item.isBooked)) {
        // eslint-disable-next-line functional/immutable-data
        slotsSortMod[0].time = this.getSlotMod(slotsSortMod, 0);
      } else {
        slotsSortMod = slotsSortMod.slice(1, slotsSortMod.length);
      }
      // eslint-disable-next-line functional/immutable-data
      slotsSortMod[slotsSortMod.length - 1].time = this.getSlotMod(slotsSortMod, slotsSortMod.length - 1);

      return [slotsSortMod];
    } else {
      return slots;
    }
  }

  private slotModTime(timeZone, slots: GridSlot[]): GridSlotTime[] {
    return slots.reduce((item: GridSlotTime[], slot: GridSlot) => {
      slot.time.forEach(it => {
        // eslint-disable-next-line functional/immutable-data
        item.push({
          duration: it.duration,
          isAvailable: it.isAvailable,
          isBooked: it.isBooked,
          slot: it.startDatetime && format(this.calendarService.userDateTime(it.startDatetime, timeZone), 'HH:mm'),
          startDatetime: it.startDatetime,
        });
      });
      return item;
    }, [] as GridSlotTime[]);
  }

  private groupSortSlots(timeZone, slot: GridSlotTime[]): GridSlot[] {
    const occurrenceDay = (occurrence: GridSlotTime): string => {
      const userDate = this.calendarService.userDateTime(occurrence.startDatetime, timeZone);
      return format(userDate, 'yyyy-MM-dd');
    };
    return chain(slot).groupBy(occurrenceDay).map(groupToDay).sortBy('date').value() as unknown as GridSlot[];
  }

  private getSlotMod(slot, index): GridSlotTime[] {
    return slot[1].time.map(item => {
      return (
        slot[index].time.find(item1 => item1.slot === item.slot) ?? {
          duration: item.duration,
          slot: item.slot,
          isAvailable: false,
          isBooked: false,
          startDatetime: slot[1].time.startDatetime,
        }
      );
    });
  }
}
